import { Map } from 'immutable';

import * as SimstreamConstants from './constants';
import * as D from './deps';

export const INITIAL_STATE = Map({
  [SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA]: null,
});

export default D.createReducer(INITIAL_STATE, {
  [SimstreamConstants.ActionKeys.CLEAR_STREAM_VIOLATION]: clearStreamViolation,
  [SimstreamConstants.ActionKeys.UPDATE_STREAM_VIOLATION_IS_STALE]: updateStreamViolationIsStale,
  [SimstreamConstants.ActionKeys.CREATE_STREAM_VIOLATION]: createStreamViolation,
});

function clearStreamViolation(state) {
  return state.set(SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA, null);
}

function updateStreamViolationIsStale(state) {
  if (!state.get(SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA)) {
    return state;
  }
  return state.mergeIn([SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA], {
    [SimstreamConstants.ReducerKeys.IS_STALE]: true,
  });
}

function createStreamViolation(state, action) {
  return state.merge({
    [SimstreamConstants.ReducerKeys.STREAM_VIOLATION_DATA]: {
      [SimstreamConstants.ReducerKeys.ERROR_DATA]: action.data,
      [SimstreamConstants.ReducerKeys.IS_STALE]: false,
    },
  });
}
